module.exports = __webpack_public_path__ + "media/58.0a92780f.wav";